import { useQuery } from "@tanstack/react-query";
import { makeApiRequest } from "../../utils";
import { CARBON_OFFSET_INVENTORY_POOLS_QUERY_KEY } from "../../../constants/queryKeys";

export const useFetchInventoryPools = () => {
  return useQuery({
    queryKey: [CARBON_OFFSET_INVENTORY_POOLS_QUERY_KEY],
    queryFn: async () => {
      return makeApiRequest({
        endpoint: "/api/carbon_offset/inventory_pools",
        method: "GET"
      });
    },
    keepPreviousData: false
  });
};
